import { Flex, FlexItem, Header, Layout } from '@bfa/common-ui';
import React from 'react';

import ErrorScreen from '../../../components/Error';
import ReCaptchaScript from '../../../components/ReCaptchaScript';
import { headerBaseProps } from '../../../utils/header';
import LoginForm from '../../Splash/components/LoginModal/LoginForm';
import { DEFAULT_LOGIN_CONFIRMATION_FLOW } from '../constants';
import useLoginConfirmationActions, {
  LoginConfirmationEventLabels,
} from '../hooks/useLoginConfirmationActions';

interface PageHeaderProps {
  onCrossClick: () => void;
  onLogoClick: () => void;
}

const PageHeader = ({
  onLogoClick,
  onCrossClick,
}: PageHeaderProps): JSX.Element => (
  <Header
    {...headerBaseProps}
    minimum
    cross
    showSecure={false}
    onLogoClick={onLogoClick}
    onCrossClick={onCrossClick}
  />
);

export interface LoginConfirmationPageProps {
  loginFlow?: string;
  program?: string;
  recaptchaEnabled?: boolean;
  title?: string;
  disclaimer?: string;
  eventLabels?: LoginConfirmationEventLabels;
  error?: boolean;
  closeTarget?: string;
}

const LoginConfirmation = ({
  loginFlow,
  program,
  recaptchaEnabled = false,
  title,
  disclaimer,
  eventLabels,
  error,
  closeTarget,
}: LoginConfirmationPageProps): JSX.Element => {
  const {
    logMemberExitLoginConfirmation,
    exitLoginConfirmation,
    eventsExtraProperties,
  } = useLoginConfirmationActions(
    loginFlow ?? DEFAULT_LOGIN_CONFIRMATION_FLOW,
    program,
    eventLabels,
    closeTarget
  );

  if (error) {
    return <ErrorScreen />;
  }

  const header = (
    <PageHeader
      onLogoClick={logMemberExitLoginConfirmation}
      onCrossClick={exitLoginConfirmation}
    />
  );
  return (
    <>
      <ReCaptchaScript />
      <Layout header={header}>
        <Flex>
          <FlexItem flex={1}>
            <LoginForm
              recaptchaEnabled={recaptchaEnabled}
              title={title}
              disclaimer={disclaimer}
              eventsExtraProperties={eventsExtraProperties}
              isAuth0SilenceLoginEnabled={false}
            />
          </FlexItem>
        </Flex>
      </Layout>
    </>
  );
};

export default LoginConfirmation;
